/* eslint-disable vue/max-len */
export default class TreeNode {
  children = [];

  data = {};

  options = {};

  expanded = false;

  mountKey = 1;

  isTreeNode = true;

  constructor (data, options = {}, parentData) {
    this.options = options;

    if (options.mountKey) this.mountKey = options.mountKey;

    this.data = data;

    if (options.DataEntity) {
      Object.assign(this, new options.DataEntity(data, parentData));
      Object.defineProperties(this, Object.getOwnPropertyDescriptors(options.DataEntity.prototype));
    }

    this.createSubtree(data);

    if (typeof this.options.formatFunction === 'function') {
      this.options.formatFunction(this);
    }
  }

  createSubtree (data) {
    const { childProperty } = this.options;
    const childrenData = data[childProperty];

    if (Array.isArray(childrenData)) {
      const data = typeof this.options.filterFunction === 'function' ? childrenData.filter(item => this.options.filterFunction(item)) : childrenData;
      this.children = data.map(childData => new TreeNode(childData, this.options, this));
    }
  }

  sortSubtree (sort = {}) {
    if (!this.children || !sort.key) return;
    if (this.children.length === 1) this.children[0].sortSubtree(sort);
    else {
      this.children.sort((a, b) => {
        a.sortSubtree(sort);
        b.sortSubtree(sort);
        return sort.value === 'asc' ? a.getSortValue(sort.key) - b.getSortValue(sort.key) : b.getSortValue(sort.key) - a.getSortValue(sort.key);
      });
    }
  }

  get hasChildren () {
    return !!this.children && this.children.length > 0;
  }

  switchExpanded () {
    this.expanded = !this.expanded;
  }

  get isExpanded () {
    return this.expanded;
  }

  get isExpandable () {
    return this.hasChildren;
  }
};
